import ko from "knockout";
import "flow/bindings/intSpaceIfZeroFormatterBinding";
import viewHtml from "./numberInput.html";
import { INumberParams } from "./number";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";

ko.components.register("ko-numberinput", {
    viewModel: function (params: INumberParams) {
        this.value = params.value;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_numberinput", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
